// @ts-nocheck

import { defaultLicence } from '../constants/runtime';
import { changeLanguageL10n } from '../i18n/l10n';
import { CommonActionTypes } from '../types/actions/common';
import { RuntimeActionTypes } from '../types/actions/runtime';
import { UserActionTypes } from '../types/actions/user';
import { Licences, Locales } from '../types/common';

export const runtimeInitialState = {
  licence: defaultLicence,
  isWTVEnabled: false,
  isCashoutEnabled: false,
  isMyMatchEnabled: false,
  isMyMatchSoccerEnabled: false,
  isMyMatchSoccerLiveEnabled: false,
  isMyMatchBasketballEnabled: false,
  isWebsocketConnected: false,
  isStreamHighlightsEnabled: false,
  overrideSettings: null,
};

const getNewLanguage = (licence) => {
  let newLanguage = Locales.FR;
  switch (licence) {
    case Licences.ES:
      newLanguage = Locales.ES;
      break;
    case Licences.DE:
      newLanguage = Locales.DE;
      break;
    default:
      newLanguage = Locales.FR;
      break;
  }
  return newLanguage;
};

export default (state = runtimeInitialState, action) => {
  switch (action.type) {
    case UserActionTypes.SET_DISCONNECTED: {
      return {
        ...state,
        overrideSettings: null,
      };
    }

    case RuntimeActionTypes.SET_LICENCE: {
      const { licence } = action.payload;
      if (licence && licence !== state.licence && Object.keys(Licences).indexOf(licence) !== -1) {
        // need to switch languague here to update ajax endpoints and login form

        const newLanguage = getNewLanguage(licence);
        changeLanguageL10n(newLanguage);
        return {
          ...state,
          licence,
        };
      }
      return state;
    }

    case RuntimeActionTypes.SET_OVERRIDE_SETTINGS: {
      return {
        ...state,
        overrideSettings: action.payload.overrideSettings,
      };
    }

    case CommonActionTypes.RECEIVE_ENTITIES: {
      const { settings } = action.payload;

      if (settings) {
        const isWTVEnabled = settings.winamaxtvIsLive ?? state.isWTVEnabled;
        const isCashoutEnabled = settings.cashoutAvailable ?? state.isCashoutEnabled;
        const isMyMatchEnabled = settings.mymatchAvailable ?? state.isMyMatchEnabled;
        const isMyMatchSoccerEnabled = settings.mymatchSoccerAvailable ?? state.isMyMatchSoccerEnabled;
        const isMyMatchSoccerLiveEnabled = settings.mymatchSoccerLiveAvailable ?? state.isMyMatchSoccerLiveEnabled;
        const isMyMatchBasketballEnabled = settings.mymatchBasketballAvailable ?? state.isMyMatchBasketballEnabled;
        const isStreamHighlightsEnabled = settings.streamHighlightsEnabled ?? state.isStreamHighlightsEnabled;

        // Gestion des overrides
        if (state.overrideSettings) {
          return {
            ...state,
            isWTVEnabled: state.overrideSettings.winamaxtvIsLive ?? isWTVEnabled,
            isCashoutEnabled: state.overrideSettings.cashoutAvailable ?? isCashoutEnabled,
            isMyMatchEnabled: state.overrideSettings.mymatchAvailable ?? isMyMatchEnabled,
            isMyMatchSoccerLiveEnabled: state.overrideSettings.mymatchSoccerAvailable ?? isMyMatchSoccerLiveEnabled,
            isMyMatchSoccerEnabled: state.overrideSettings.mymatchSoccerLiveAvailable ?? isMyMatchSoccerEnabled,
            isMyMatchBasketballEnabled: state.overrideSettings.mymatchBasketballAvailable ?? isMyMatchBasketballEnabled,
            isStreamHighlightsEnabled: state.overrideSettings.streamHighlightsEnabled ?? isStreamHighlightsEnabled,
          };
        }

        return {
          ...state,
          isWTVEnabled,
          isCashoutEnabled,
          isMyMatchEnabled,
          isMyMatchSoccerLiveEnabled,
          isMyMatchSoccerEnabled,
          isMyMatchBasketballEnabled,
          isStreamHighlightsEnabled,
        };
      }
      return state;
    }

    case RuntimeActionTypes.SET_WEBSOCKET_IS_CONNECTED: {
      const { isConnected } = action.payload;
      return {
        ...state,
        isWebsocketConnected: isConnected,
      };
    }

    default:
      return state;
  }
};
